// Układy współrzędnych klienta. Świat: metry (x na wschód, y na południe). Ekran: izometria 2:1.
export interface WorldConfig {
  origin_e: number; origin_n: number; tile_size_m: number; chunk_tiles: number; region_size_m: number;
  chunk_format: number; tick_hz: number; attribution: string;
}

/** Piksele na kafelek w przestrzeni sceny (zoom 1). */
export const TILE_W = 32;
export const TILE_H = 16;

export class Grid {
  constructor(public tile = 1.0, public chunkTiles = 64) {}

  worldToTile(x: number, y: number): [number, number] {
    return [Math.floor(x / this.tile), Math.floor(y / this.tile)];
  }

  worldToChunk(x: number, y: number): [number, number] {
    const [tx, ty] = this.worldToTile(x, y);
    return [Math.floor(tx / this.chunkTiles), Math.floor(ty / this.chunkTiles)];
  }

  /** Kafelek (może być ułamkowy) → piksele sceny. */
  tileToScreen(tx: number, ty: number): [number, number] {
    return [(tx - ty) * TILE_W / 2, (tx + ty) * TILE_H / 2];
  }

  worldToScreen(x: number, y: number): [number, number] {
    return this.tileToScreen(x / this.tile, y / this.tile);
  }

  screenToWorld(sx: number, sy: number): [number, number] {
    const a = sx / (TILE_W / 2), b = sy / (TILE_H / 2);
    return [((a + b) / 2) * this.tile, ((b - a) / 2) * this.tile];
  }

  /** Głębokość rysowania (painter's algorithm): dalej = wcześniej. */
  depth(x: number, y: number, layer = 0): number {
    return (x + y) / this.tile * 10 + layer;
  }
}
